<template>
    <div class="container">
        <container :active_path="path" :plate="'云项目'">
            <div class="base-warp">
                <div class="head">
                    <div class="title-text">公众号设置</div>
                    <div class="right-box">
                        <el-button type="primary" size="mini" @click="add">添加公众号</el-button>
                    </div>
                </div>
                <el-row :gutter="0" class="base-content">
                    <el-col :span="12" :offset="0">
                        <el-card 
                        v-for="(item, index) in official"
                        :key="index"
                        class="box-card"
                        shadow="always">
                            <el-form :model="item" label-width="100px" :inline="false" size="normal">
                                <el-form-item label="公众号名称">
                                    <el-input v-model="item.name" size="mini"></el-input>
                                </el-form-item>
                                <el-form-item label="appid">
                                    <el-input v-model="item.appid" size="mini"></el-input>
                                </el-form-item>
                                <el-form-item label="appsecret">
                                    <el-input v-model="item.appsecret" size="mini"></el-input>
                                </el-form-item>
                                <el-form-item label="access_token">
                                    <el-input v-model="item.access_token" size="mini" disabled></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" size="mini" @click="save(item, index)">保存</el-button>
                                    <el-button size="mini" @click="reset(index)">重置</el-button>
                                    <el-button type="danger" size="mini" @click="del(item, index)">删除</el-button>
                                    <el-button type="warning" size="mini" @click="refresh(item, index)">刷新token</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
            
        </container>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            path: '/project/official',
            official: [],
            baseOfficial: [],
        }
    },
    mounted () {
        this.getData();
    },
    methods: {
        refresh(item, index) {
            this.$confirm('是否确定刷新').then(
                confirm=>{
                    var parmas = {
                        id: item._id['$oid']
                    }
                    this.$api.refreshAccessToken(parmas).then(
                        data=>{
                            this.$message.success('刷新成功');
                            this.official[index] = data;
                            this.baseOfficial[index] = data;
                        }
                    )
                },
                cancel=>{}
            )
        },
        getData() {
            this.$api.getOfficial('').then(
                data=>{
                    this.official = data;
                    for(var item of data){
                        this.baseOfficial.splice(0, 0, item);
                    }
                    console.log(this.baseOfficial)
                }
            )
        },
        save(item, index) {
            this.$confirm('是否确定保存').then(
                confirm=>{
                    if (!item._id){
                        var params = {
                            name: item.name,
                            appid: item.appid,
                            appsecret: item.appsecret,
                        };
                        this.$api.addOfficial(params).then(
                            data=>{
                                this.$message.success(data);
                                this.official[index].type = 'save';
                            }
                        )
                        return
                    }
                    var params = {
                        id: item._id['$oid'],
                        name: item.name,
                        appid: item.appid,
                        appsecret: item.appsecret,
                    }
                    this.$api.editOfficial(params).then(
                        data=>{
                            this.$message.success(data);
                        }
                    )
                    
                },
                cancel=>{}
            )
        },
        reset(index) {
            if (this.baseOfficial[index]) {
                console.log(this.baseOfficial[index])
                this.official[index] = this.baseOfficial[index];
                return;
            }
            var obj = {
                name: '',
                appid: '',
                appsecret: '',
                type: 'add',
            };
            this.official[index] = obj;
        },
        del(item, index) {
            this.$confirm('是否确定删除当前公众号，删除后不可恢复').then(
                confirm=>{
                    var params = {
                        id: item._id['$oid'],
                    };
                    this.$api.delOfficial(params).then(
                        data=>{
                            this.$message.success('删除成功');
                            this.official.splice(index, 1);
                        }
                    )
                },
                cancel=>{}
            )
        },
        add() {
            var len = this.official.length;
            if (len>0){
                if (this.official[len-1]['type']=='add'){
                    this.$message.error('不要重复点击');
                    return;
                }
            }
            
            var obj = {
                name: '',
                appid: '',
                appsecret: '',
                type: 'add',
            };
            this.official.push(obj);
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item.el-form-item--normal{
    margin-bottom: 0;
}
.box-card{
    margin-bottom: 10px;
}
</style>